// extracted by mini-css-extract-plugin
export default {"collapser":"Collapser_collapser__aLP0X","collapsedIcon":"Collapser_collapsedIcon__-PNBw"};